import {
  Bar,
  mixins
} from 'vue-chartjs'
const {
  reactiveProp
} = mixins

export default Bar.extend({
  mixins: [reactiveProp],
  props: ['options'],
  watch: {
    'options': {
      handler(newOption, oldOption) {
        this._chart.destroy()
        this.renderChart(this.chartData, this.options)
      },
      deep: true
    }
  },
  mounted() {
    this.renderChart(this.chartData, this.options)
  }
})



// WEBPACK FOOTER //
// ./src/components/Charts/BarChart_KM.js